<template>
  <main-button :color="'white'"
               @click="IS_ACTIVE_MODAL(true)">
    {{ btnText }}
  </main-button>
</template>

<script>
import MainButton from "@/components/shared/MainButton.vue";
import {mapActions} from "vuex";

export default {
  name: "ButtonRequest",
  components: {MainButton},
  data() {
    return {
      btnText: 'Оставить заявку'
    }
  },
  methods: {
    ...mapActions(['IS_ACTIVE_MODAL']),
  }
}
</script>

<style scoped>

</style>